/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// actions
import {
    EXPORTING_COMMENTING_ANALYTICS
  } from 'state/actions/commentingState/exportStatus';


/* ========== ~~~~~~~~~~ EXPORT STATE > COMMENTS STATUS: REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {
    isExporting: false
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const exportStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case EXPORTING_COMMENTING_ANALYTICS:
            newState.isExporting = action.status;
            return newState;
        default:
            return state;
    }
};

/* ++++++++++ --------------- CUSTOM METHODS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default exportStatus;
